/* ============================================================
   CHIARA WONDER — global.js
   Vanilla JS · No framework · Performance-first · Mobile-first
   v3: scroll preservation pattern + cart remove via line index
   ============================================================ */

(function() {
  'use strict';

  /* ============================================================
     FOCUS MANAGEMENT (T5 / A11Y-04, A11Y-05)
     - Input modality: html.cw-pointer after a mouse/touch press, removed on Tab/Escape.
       base.css shows the focus ring only outside pointer mode, so mouse users see no change
       (even when focus is moved by script, e.g. drawer opened after an ATC click).
     - Focus trap of drawer / menu / search: window.CW.trapFocus (cw-v40-core.js). The old unused
       body scroll lock and trapFocus/releaseFocus copy (with their global keydown/focusin
       listeners) were removed here (CRO08 R7).
     ============================================================ */
  var docEl = document.documentElement;
  document.addEventListener('pointerdown', function() { docEl.classList.add('cw-pointer'); }, true);
  document.addEventListener('mousedown', function() { docEl.classList.add('cw-pointer'); }, true);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Tab' || e.key === 'Escape') docEl.classList.remove('cw-pointer');
  }, true);

  /* ============================================================
     CART BRIDGE (v40)
     The cart drawer, the badge, the cart page and the ONE cart:refresh listener live in assets/cw-v40-core.js
     (window.CW, loaded before this file). These helpers are kept for the PDP flow below and for old callers:
     they delegate to CW and keep a minimal fallback when the core is missing.
     Removed in v40 (now in cw-v40-core.js): drawer open/close + Esc, drawer line change/remove, legacy mobile menu
     [data-menu-toggle], legacy search overlay [data-search-overlay-open], inert desktop dropdown [data-nav-dropdown],
     and the cart:refresh listener (single listener rule, CLAUDE.md).
     ============================================================ */
  function getCartDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openCartDrawer(opener) {
    if (window.CW && window.CW.openCart) { window.CW.openCart(opener); return; }
    window.location.href = '/cart';
  }

  function updateCartCountUI(count, total) {
    if (window.CW && window.CW.cart) window.CW.cart.setCount(count, total);
  }

  function reloadCartDrawer() {
    if (window.CW && window.CW.cart) return window.CW.cart.refresh();
    return Promise.resolve();
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(cart) {
        if (cart && typeof cart.item_count === 'number') updateCartCountUI(cart.item_count, cart.total_price);
        return cart;
      })
      .catch(function(err) { console.warn('[CW] refreshCartCount:', err); return null; });
  }


  /* ---------- PDP form AJAX submit ----------
     CW-001: unico proprietario del submit di .pdp-form (lo script inline di
     main-product.liquid non intercetta piu' il submit). 1 submit = 1 POST.
     Guard in-flight su data-cw-busy; nessun re-submit nativo dopo un errore
     (evitava doppi add quando l'add era gia' riuscito). */
  function setPdpBusy(form, atcBtn, stickyBtn, busy) {
    if (busy) form.setAttribute('data-cw-busy', 'true');
    else form.removeAttribute('data-cw-busy');
    [atcBtn, stickyBtn].forEach(function(btn) {
      if (!btn) return;
      btn.classList.toggle('is-loading', busy);
      if (busy) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    });
  }

  /* CW-016 / ENG-08: form PDP gestiti in AJAX.
     - Skin: form.pdp-form (main-product.liquid).
     - Atelier: form[data-pdp-form] SOLO dentro la section main-product-atelier
       (.pdp-atelier-page, file protetto). Le card collection (snippets/atelier-card.liquid)
       usano anch'esse data-pdp-form ma restano a submit nativo (comportamento invariato). */
  // v40: form[data-cw-product-form] (prototype contract) is owned here too: ONE submit owner.
  var PDP_FORM_SELECTOR = 'form.pdp-form, form[data-cw-product-form], .pdp-atelier-page form[data-pdp-form]';

  function getPdpScope(el) {
    return (el && el.closest && el.closest('[data-section-id]')) || document;
  }

  function findPdpForm(fromEl) {
    var scope = getPdpScope(fromEl);
    return scope.querySelector(PDP_FORM_SELECTOR) ||
      (scope !== document ? document.querySelector(PDP_FORM_SELECTOR) : null);
  }

  function showPdpError(form, msg) {
    var el = form.querySelector('[data-atc-error]');
    var created = false;
    if (!el) {
      // Atelier: il markup protetto non ha [data-atc-error]. Fallback runtime
      // (solo DOM, nessuna modifica al file): creato al primo errore, dentro il form.
      if (!msg || !form.closest('.pdp-atelier-page')) return;
      el = document.createElement('p');
      el.className = 'cw-atc-error';
      el.setAttribute('data-atc-error', '');
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:12px 0 0;font-size:13px;line-height:1.45;';
      form.appendChild(el);
      created = true;
    }
    if (msg) {
      // B1 (CRO08): Skin + Atelier. ATC from the sticky bar (form off screen) -> the error is ALSO shown as a toast
      // (error variant, above sticky and cookie banner) and the page does not move. Announced ONCE: when the toast
      // speaks, the inline paragraph loses role="alert" for this message (CRO12 V08).
      if (!el.hasAttribute('data-cw-role')) el.setAttribute('data-cw-role', el.getAttribute('role') || '');
      el.removeAttribute('hidden');
      var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      var off = !!r && (r.top < 0 || r.bottom > window.innerHeight || (!r.width && !r.height));
      var canToast = !!(window.CW && typeof window.CW.toast === 'function' && document.querySelector('[data-cw-toasts]'));
      if (off && canToast) el.removeAttribute('role');
      else if (el.getAttribute('data-cw-role')) el.setAttribute('role', el.getAttribute('data-cw-role'));
      el.textContent = msg;
      if (off) {
        if (canToast) window.CW.toast(msg, { kind: 'error', duration: 7000 });
        else { try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
      }
    } else { el.textContent = ''; el.setAttribute('hidden', ''); }
  }

  function handlePdpSubmit(form) {
    if (!window.fetch) { form.submit(); return; }
    if (form.getAttribute('data-cw-busy') === 'true') return; // click ripetuti: ignorati

    var atcBtn = form.querySelector('[data-atc-button]') || form.querySelector('[type="submit"]');
    if (atcBtn && atcBtn.disabled) return; // variante non disponibile
    var scope = getPdpScope(form);
    var stickyBtn = scope.querySelector('[data-sticky-atc]') ||
      (scope !== document ? document.querySelector('[data-sticky-atc]') : null);

    // Nota: non si tocca innerHTML/disabled dei bottoni: il variant picker inline
    // tiene riferimenti agli span label e gestisce disabled in base alla disponibilita'.
    setPdpBusy(form, atcBtn, stickyBtn, true);
    showPdpError(form, '');

    var snapBefore = (window.CW && window.CW.cart && window.CW.cart.snapshot) ? window.CW.cart.snapshot() : null;
    var countBefore = snapBefore ? snapBefore.item_count : null;
    var formData = new FormData(form);
    // quantity from input[name="quantity"], clamped 1-20 (same rule as the v40 core)
    var qty = parseInt(formData.get('quantity'), 10);
    if (!isNaN(qty)) formData.set('quantity', String(Math.max(1, Math.min(20, qty))));
    var secs = (window.CW && window.CW.cart && window.CW.cart.sections) ? window.CW.cart.sections().join(',') : 'cart-drawer';
    formData.append('sections', secs);
    formData.append('sections_url', window.location.pathname);

    // F-09: timeout 15s, per non lasciare il bottone in caricamento con rete bloccata
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function() { ctrl.abort(); }, 15000) : null;

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      signal: ctrl ? ctrl.signal : undefined
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().catch(function() { return null; }).then(function(err) {
          var e = new Error(err && err.description ? err.description : 'Add failed (' + res.status + ')');
          e.status = res.status;
          // only a 422 carries a shopper message in Italian (stock, limits); 429/5xx/4xx get the neutral text below
          e.userMessage = (res.status === 422 && err && err.description) ? String(err.description) : '';
          throw e;
        });
      }
      // F-07: add riuscito (2xx) anche se il body non e' JSON valido -> drawer ricaricato sotto
      return res.json().catch(function() { return null; });
    })
    .then(function(data) {
      // Add riuscito: da qui in poi nessun errore deve generare un nuovo add.
      // v40: drawer + cart page from the same response (CW.cart.applySections), then the contract events
      // (cart:added {items, source:'pdp'}, cart:refresh {cart, applied:true}: the core listener does not refetch).
      if (window.CW && window.CW.cart) {
        var applied = false;
        try { applied = window.CW.cart.applySections(data && data.sections); } catch (eA) { console.warn('[CW] drawer render:', eA); }
        var ready = applied ? Promise.resolve() : reloadCartDrawer();
        return ready.then(function() {
          var added = (data && data.items) ? data.items : (data ? [data] : []);
          window.CW.emit('cart:added', { items: added, source: 'pdp' });
          window.CW.emit('cart:refresh', { cart: window.CW.cart.snapshot(), source: 'pdp', applied: true });
          openCartDrawer(atcBtn);
        });
      }
      var rendered = false;
      try {
        if (data && data.sections && data.sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('[data-cart-drawer]');
          var currentDrawer = getCartDrawer();
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            rendered = true;
          }
        }
      } catch (e1) { console.warn('[CW] drawer render:', e1); }
      var drawerReady = rendered ? Promise.resolve() : reloadCartDrawer();
      return drawerReady.then(function() {
        openCartDrawer();
        return refreshCartCount();
      });
    }, function(err) {
      console.warn('[CW] AJAX ATC failed:', err);
      if (err && err.userMessage) { // es. 422 Shopify
        showPdpError(form, err.userMessage);
        // A-1: un 422 puo' aver aggiunto una quantita' parziale ("Solo N articoli...").
        // Si riallineano drawer e badge (senza aprire il drawer: il messaggio resta visibile).
        return Promise.all([reloadCartDrawer(), refreshCartCount()]).catch(function() {});
      }
      // R-03: timeout o rete. L'add potrebbe essere riuscito lato server: si verifica
      // il carrello prima di invitare a riprovare (evita un secondo add manuale).
      var variantId = String(formData.get('id') || '');
      // CRO10 P3-B: no blame on the shopper's connection for 429/5xx/timeout; network error -> check the connection
      var failMsg = (err && !err.status && err.name !== 'AbortError')
        ? 'Non siamo riusciti ad aggiungere il prodotto. Controlla la connessione e riprova.'
        : 'Non siamo riusciti ad aggiungere il prodotto. Riprova tra qualche istante.';
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) {
          var inCart = !!(cart && cart.items && cart.items.some(function(it) { return String(it.variant_id) === variantId; }));
          // the variant may have been in the cart BEFORE this add: count must have grown (CRO08 note on R-03)
          if (inCart && countBefore !== null && cart && typeof cart.item_count === 'number' && cart.item_count <= countBefore) inCart = false;
          if (!inCart) {
            showPdpError(form, failMsg);
            return;
          }
          showPdpError(form, 'Controlla il carrello: il prodotto potrebbe essere già stato aggiunto.');
          if (cart && typeof cart.item_count === 'number') updateCartCountUI(cart.item_count);
          return reloadCartDrawer().then(function() { openCartDrawer(); });
        })
        .catch(function() {
          showPdpError(form, 'Non è stato possibile verificare il carrello. Controlla il carrello prima di riprovare.');
        });
    })
    .catch(function(err) {
      console.warn('[CW] post-ATC update failed:', err);
    })
    .then(function() {
      if (timer) clearTimeout(timer);
      setPdpBusy(form, atcBtn, stickyBtn, false);
    });
  }

  // Form submit intercept. CAPTURE phase on document (T1 tracking fix 22/10/2026): Shopify's shop_events_listener
  // binds its own 'submit' listener directly on every form[action*="/cart/add"] at window load and emits
  // product_added_to_cart ("add-form") unless the event is already defaultPrevented; it also emits one ("add-fetch")
  // from the /cart/add.js fetch below. A bubble listener on body ran AFTER the form's own listener -> 2 events per click
  // (GA4, Ads and Meta x2). Preventing in capture keeps only the fetch-based event (with cart token).
  document.addEventListener('submit', function(e) {
    var form = e.target.closest && e.target.closest(PDP_FORM_SELECTOR);
    if (!form) return;
    e.preventDefault();
    handlePdpSubmit(form);
  }, true);

  // Sticky CTA → trigger submit del form PDP della stessa section (Skin o Atelier), iOS-safe
  document.body.addEventListener('click', function(e) {
    var stickyBtn = e.target.closest('[data-sticky-atc]');
    if (!stickyBtn || stickyBtn.disabled) return;
    e.preventDefault();
    var form = findPdpForm(stickyBtn);
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      if (!form.dispatchEvent(submitEvent)) return;
      form.submit();
    }
  });

  /* ============================================================
     COOKIE BANNER
     ============================================================ */
  var cookieBanner = document.querySelector('[data-cookie-banner]');
  var COOKIE_KEY = 'cw_cookie_consent_v1';
  if (cookieBanner) {
    try {
      if (!localStorage.getItem(COOKIE_KEY)) {
        setTimeout(function() {
          cookieBanner.classList.add('is-visible');
        }, 800);
      }
    } catch (e) {}
  }
  document.body.addEventListener('click', function(e) {
    var acceptBtn = e.target.closest('[data-cookie-accept]');
    var declineBtn = e.target.closest('[data-cookie-decline]');
    if (acceptBtn || declineBtn) {
      e.preventDefault();
      try {
        localStorage.setItem(COOKIE_KEY, acceptBtn ? 'accepted' : 'declined');
      } catch (err) {}
      if (cookieBanner) cookieBanner.classList.remove('is-visible');
    }
  });

  /* ============================================================
     SCROLL REVEAL (progressive enhancement, fail-safe)
     ============================================================ */
  var reveals = document.querySelectorAll('.cw-reveal');
  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      // Attiva il "nascondi" solo ORA che possiamo gestire il reveal.
      document.documentElement.classList.add('js-reveal-ready');
      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      reveals.forEach(function(el) { revealObserver.observe(el); });

      // FAIL-SAFE: se dopo 1.2s qualche elemento non e' stato rivelato
      // (observer non scattato, elemento gia' in viewport, edge case Safari),
      // lo riveliamo comunque per non lasciare contenuto invisibile.
      setTimeout(function() {
        reveals.forEach(function(el) {
          if (!el.classList.contains('is-visible')) {
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight) { el.classList.add('is-visible'); }
          }
        });
      }, 1200);
    }
    // Se IntersectionObserver non esiste: non aggiungiamo js-reveal-ready,
    // quindi il CSS lascia tutto VISIBILE di default. Nessun contenuto nascosto.
  }

  /* ============================================================
     STICKY MOBILE CTA HOME (hero-dual)
     ============================================================ */
  var heroDual = document.querySelector('[data-section="hero-dual"]');
  if (heroDual) {
    var homeStickyCTA = document.querySelector('[data-sticky-cta]');
    var footer = document.querySelector('footer');
    if (homeStickyCTA && footer) {
      var updateHomeStickyCTA = function() {
        var heroBottom = heroDual.getBoundingClientRect().bottom;
        var footerTop = footer.getBoundingClientRect().top;
        var viewportHeight = window.innerHeight;
        var shouldShow = heroBottom < 0 && footerTop > viewportHeight - 100;
        homeStickyCTA.classList.toggle('is-visible', shouldShow);
      };
      window.addEventListener('scroll', updateHomeStickyCTA, { passive: true });
      updateHomeStickyCTA();
    }
  }

  /* ============================================================
     ACCORDION
     ============================================================ */
  document.querySelectorAll('[data-accordion-toggle]').forEach(function(btn) {
    var parent = btn.closest('[data-accordion-item]');
    if (!parent) {
      // ENG-30: accordion Atelier (.accordion/.open) gestito dallo script del file protetto.
      // Qui si sincronizza solo aria-expanded, dopo che quel listener ha togglato la classe.
      var acc = btn.closest('.accordion');
      if (!acc) return;
      btn.setAttribute('aria-expanded', String(acc.classList.contains('open')));
      btn.addEventListener('click', function() {
        setTimeout(function() {
          btn.setAttribute('aria-expanded', String(acc.classList.contains('open')));
        }, 0);
      });
      return;
    }
    btn.addEventListener('click', function() {
      var isOpen = parent.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(!!isOpen));
    });
  });

  /* ============================================================
     ANNOUNCEMENT BAR PAUSE ON HOVER
     ============================================================ */
  var announcement = document.querySelector('[data-announcement-track]');
  if (announcement) {
    announcement.addEventListener('mouseenter', function() {
      announcement.style.animationPlayState = 'paused';
    });
    announcement.addEventListener('mouseleave', function() {
      announcement.style.animationPlayState = 'running';
    });
  }

  /* ============================================================
     SMOOTH ANCHOR SCROLL
     ============================================================ */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (!href || href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        /* Move keyboard focus with the scroll (skip link, in-page anchors). */
        if (!target.matches('a[href], button, input, select, textarea, [tabindex]')) {
          target.setAttribute('tabindex', '-1');
        }
        target.focus({ preventScroll: true });
      }
    });
  });

  /* ============================================================
     WISHLIST (localStorage, no login richiesto)
     - click cuore: toggle salva/rimuovi
     - persistenza su dispositivo
     - stato visivo is-saved
     - count aggiornato in tutti i [data-wishlist-count]
     - evento 'wishlist:change' per la pagina wishlist
     ============================================================ */
  var WISHLIST_KEY = 'cw_wishlist';

  function wishlistGet() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function wishlistSave(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    updateWishlistCount(list.length);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list } }));
  }
  function wishlistHas(handle) { return wishlistGet().indexOf(handle) !== -1; }
  function wishlistToggle(handle) {
    if (!handle) return false;
    var list = wishlistGet();
    var i = list.indexOf(handle);
    var saved;
    if (i === -1) { list.push(handle); saved = true; }
    else { list.splice(i, 1); saved = false; }
    wishlistSave(list);
    return saved;
  }
  function updateWishlistCount(n) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  // Stato iniziale: marca i cuori dei prodotti già salvati + count
  function syncWishlistButtons() {
    document.querySelectorAll('[data-wishlist]').forEach(function(btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      if (handle) {
        var has = wishlistHas(handle);
        btn.classList.toggle('is-saved', has);
        btn.setAttribute('aria-pressed', String(has));
      }
    });
    updateWishlistCount(wishlistGet().length);
  }
  syncWishlistButtons();

  // Click delegato globale sul cuore (funziona su collection, PDP, ovunque)
  document.body.addEventListener('click', function(e) {
    var wishBtn = e.target.closest('[data-wishlist]');
    if (!wishBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = wishBtn.getAttribute('data-wishlist-handle');
    if (!handle) return; // senza handle non possiamo persistere
    var saved = wishlistToggle(handle);
    wishBtn.classList.toggle('is-saved', saved);
    wishBtn.setAttribute('aria-pressed', String(saved));
    // micro-feedback
    wishBtn.classList.add('is-pulse');
    setTimeout(function() { wishBtn.classList.remove('is-pulse'); }, 300);
  });

  // Re-sync dopo rerender della collection (filtri/load-more)
  document.addEventListener('collection:rendered', syncWishlistButtons);
  // Espongo un minimo di API per la pagina wishlist
  window.CWWishlist = { get: wishlistGet, has: wishlistHas, toggle: wishlistToggle, remove: function(h){ var l=wishlistGet(); var i=l.indexOf(h); if(i>-1){l.splice(i,1); wishlistSave(l);} } };

})();
